import React from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { connect } from "react-redux";
import { AppleStoreButton, PlayStoreButton } from "components/PlayStoreButton";

const CenterFooter = (props) => {
  const { organizationInfo } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matchesMinWidth = useMediaQuery("(max-width:400px)");
  const isShowAppStoreBand =
    organizationInfo?.organizationOptionJson?.showAppStoreBand?.toLowerCase() ===
    "y";

  return (
    <Box>
      {isShowAppStoreBand && (
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Grid
              className="home-center-footer"
              id="home-center-footer"
              sx={{
                backgroundColor:
                  organizationInfo?.app?.appCode !== "CVD"
                    ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}  !important`
                    : undefined,
                backgroundImage:
                  organizationInfo?.app?.appCode !== "CVD"
                    ? `none !important`
                    : undefined,
                flexDirection: matchesMinWidth ? "column" : undefined,
                height: matchesMinWidth ? "12rem" : undefined,
                justifyContent: matchesMinWidth ? "center" : undefined,
              }}
            >
              <Box
                mr={1}
                ml={matches ? "12px" : "15rem"}
                sx={{
                  width: matchesMinWidth ? "60vw" : undefined,
                  marginBottom: matchesMinWidth ? "10px" : undefined,
                }}
              >
                <AppleStoreButton storeBtnId="homeStoreBtn" />
              </Box>
              <Box sx={{ width: matchesMinWidth ? "60vw" : undefined }}>
                <PlayStoreButton storeBtnId="homeStoreBtn" />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data || {},
  };
};

export default connect(mapStateToProps)(CenterFooter);